import { memo, useState } from 'react';
import { Text, View, type StyleProp, type TextStyle } from 'react-native';
import { runOnJS, useAnimatedReaction, type SharedValue } from 'react-native-reanimated';

import { layoutLtrStyle } from '../../../../shared/i18n/rtl';

type Props = {
  count: SharedValue<number>;
  style?: StyleProp<TextStyle>;
};

/**
 * Single Text readout driven by a shared value — no digit-column stack.
 * Always Latin digits + LTR island so RTL locale cannot reverse values (e.g. `001`).
 */
export const PlainAnimatedNumber = memo(function PlainAnimatedNumber({ count, style }: Props) {
  const [display, setDisplay] = useState(() => Math.round(count.value));

  useAnimatedReaction(
    () => Math.round(count.value),
    (curr, prev) => {
      if (curr !== prev) {
        runOnJS(setDisplay)(curr);
      }
    },
    [count],
  );

  return (
    <View style={layoutLtrStyle} collapsable={false}>
      <Text style={[{ writingDirection: 'ltr' }, style]} allowFontScaling={false}>
        {display}
      </Text>
    </View>
  );
});
